import React, { useReducer } from 'react'
import CouponContext from './couponContext'
import CouponReducer from './couponReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import { CLEAR_RESPONSE, RESPONSE_STATUS, GET_ALL_COUPONS } from './couponTypes'

const CouponState = (props) => {
    const initialState = {
        responseStatus: null,
        search_allcoupons: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
    }

    const [state, dispatch] = useReducer(CouponReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const payCartCoupon = async (formData) => {
        const from = 'applycoupon'
        try {
            const [res] = await Promise.all([apiCall('post', from, formData, '', 'couponcode')])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const getAllCoupons = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllAvailableCoupons', formData, '', 'couponcode'),
            ])
            const from = 'getAllCoupons'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_COUPONS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('getAllCoupons')
        }
    }
    const checkCouponDiscount = async (formData, fromVariable, custom = false) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'checkCouponDiscount',
                    formData,
                    '',
                    custom ? 'custom/couponcode' : 'couponcode',
                ),
            ])
            const from = fromVariable ? fromVariable : 'checkCouponDiscount'
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('checkCouponDiscount')
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <CouponContext.Provider
            value={{
                responseStatus: state.responseStatus,
                search_allcoupons: state.search_allcoupons,
                getAllCoupons,
                payCartCoupon,
                clearResponse,
                checkCouponDiscount,
            }}
        >
            {props.children}
        </CouponContext.Provider>
    )
}

export default CouponState
